import React from 'react';
import PropTypes from 'prop-types';
import AmortizationScheduleStyles from './AmortizationSchedule.styled';
import toCurrency from '../../util/toCurrency';

const AmortizationSchedule = ({ results = [] }) => {
  let year = results?.[0] && new Date(results?.[0]?.paymentDate).getFullYear();
  let principal = 0;
  let interest = 0;

  return (
    <AmortizationScheduleStyles>
      <div className='inner'>
        <h2 className='type-h4 no-margin-bottom'>Amortization schedule</h2>
        <p className='type-caption'>
          Please allow for slight rounding differences
        </p>
        <div className='table_wrapper'>
          <table>
            <thead>
              <tr>
                <th>
                  <p className='type-h6'>Pmt #</p>
                </th>
                <th>
                  <p className='type-h6'>Date</p>
                </th>
                <th>
                  <p className='type-h6'>Principal</p>
                </th>
                <th>
                  <p className='type-h6'>Interest</p>
                </th>
                <th>
                  <p className='type-h6'>Payment</p>
                </th>
                <th>
                  <p className='type-h6'>Balance</p>
                </th>
              </tr>
            </thead>
            <tbody>
              {results.map(
                (
                  {
                    paymentNumber,
                    paymentDate,
                    principalAmount,
                    interestAmount,
                    paymentAmount,
                    balance,
                  },
                  i
                ) => {
                  const paymentDateObj = new Date(paymentDate);
                  const row = (
                    <tr key={paymentNumber}>
                      <td>
                        <p className='type-caption'>{paymentNumber}</p>
                      </td>
                      <td>
                        <p className='type-caption'>{paymentDate}</p>
                      </td>
                      <td>
                        <p className='type-caption'>
                          {toCurrency(principalAmount, true)}
                        </p>
                      </td>
                      <td>
                        <p className='type-caption'>
                          {toCurrency(interestAmount, true)}
                        </p>
                      </td>
                      <td>
                        <p className='type-caption'>
                          {toCurrency(paymentAmount, true)}
                        </p>
                      </td>
                      <td>
                        <p className='type-caption'>
                          {toCurrency(balance, true)}
                        </p>
                      </td>
                    </tr>
                  );

                  if (paymentDateObj.getFullYear() !== year) {
                    year = paymentDateObj.getFullYear();
                  }

                  principal = parseFloat(
                    (
                      parseFloat(principal) + parseFloat(principalAmount)
                    ).toFixed(2)
                  );
                  interest = parseFloat(
                    (parseFloat(interest) + parseFloat(interestAmount)).toFixed(
                      2
                    )
                  );

                  return (
                    <>
                      {row}
                      {(paymentDateObj.getMonth() === 11 ||
                        i + 1 === results.length) && (
                        <tr className='year_total'>
                          <td>
                            <p className='type-caption'>Total</p>
                          </td>
                          <td>
                            <p className='type-caption'>{year}</p>
                          </td>
                          <td>
                            <p className='type-caption'>
                              {toCurrency(principal, true)}
                            </p>
                          </td>
                          <td>
                            <p className='type-caption'>
                              {toCurrency(interest, true)}
                            </p>
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                    </>
                  );
                }
              )}
            </tbody>
          </table>
        </div>
      </div>
    </AmortizationScheduleStyles>
  );
};

AmortizationSchedule.propTypes = {
  results: PropTypes.array.isRequired,
};

export default AmortizationSchedule;
